import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { AddTask, ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../../../../app/hooks';
import { useUpsertRecurringTaskMutation } from '../../../../../services/RecurringTaskService';

/**
 * RecurringTaskCreateHeader - Header for creating new recurring tasks
 */
export const RecurringTaskCreateHeader: React.FC = () => {
  const navigate = useNavigate();
  const { currentRecurringTask } = useAppSelector(state => state.recurringTask);
  const [upsertRecurringTask, { isLoading }] = useUpsertRecurringTaskMutation();

  const handleSave = async () => {
    if (!currentRecurringTask) return;

    try {
      await upsertRecurringTask({
        recurringTaskView: currentRecurringTask,
        modifiedBy: 'current-user@example.com', // TODO: Get from auth context
      }).unwrap();
      
      navigate('/recurring-tasks');
    } catch (error) {
      console.error('Failed to create recurring task:', error);
    }
  };

  const isValid = currentRecurringTask?.templateTitle && 
                  currentRecurringTask?.defaultTeam &&
                  currentRecurringTask?.category;

  return (
    <Box
      sx={{
        backgroundColor: '#ffffff',
        borderBottom: '2px solid #3b82f6',
        p: 2.5
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box display="flex" alignItems="center" gap={2}>
          <AddTask sx={{ fontSize: 28, color: '#3b82f6' }} />
          <Box>
            <Typography variant="h5" sx={{ fontWeight: 700, color: '#0f172a' }}>
              Create Recurring Task
            </Typography>
            <Typography variant="body2" sx={{ color: '#64748b', mt: 0.5 }}>
              Set up a template for automated ticket generation
            </Typography>
          </Box>
        </Box>
        
        <Box display="flex" gap={1.5}>
          <Button
            variant="outlined"
            startIcon={<ArrowBack />}
            onClick={() => navigate('/recurring-tasks')}
            sx={{
              borderColor: '#cbd5e1',
              color: '#475569',
              fontWeight: 600,
              '&:hover': {
                borderColor: '#94a3b8',
                backgroundColor: '#f8fafc'
              }
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSave}
            disabled={!isValid || isLoading}
            sx={{
              backgroundColor: '#162346',
              fontWeight: 600,
              px: 3,
              '&:hover': {
                backgroundColor: '#1a2a52'
              },
              '&:disabled': {
                backgroundColor: '#cbd5e1'
              }
            }}
          >
            {isLoading ? 'Creating...' : 'Create Recurring Task'}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default RecurringTaskCreateHeader;
